var addressQueryHost = process.env.VUE_APP_ADDRESS_QUERY_URL;
var mapDataHost = process.env.VUE_APP_API_MAP_DATA_HOST;

export default {
  addressQuery: addressQueryHost,

  getCentreType: mapDataHost + '/centre_type',
  getCentreInfo: mapDataHost + '/centre_info',
  
};
